import { AddToCart } from '@theme/cart-api';

class ProductAtc extends HTMLElement {
  #host = null;
  #variantInput = null;
  #priceEl = null;
  #atcButton = null;
  #notifyButton = null;
  #addToCart = null;

  connectedCallback() {
    this.#host = this.closest('main-product');
    this.#variantInput = this.querySelector('[data-atc-variant-id]');
    this.#priceEl = this.querySelector('[data-atc-price]');
    this.#atcButton = this.querySelector('[data-atc-button]');
    this.#notifyButton = this.querySelector('[data-notify-button]');

    try {
      this.#addToCart = new AddToCart(this);
    } catch (err) {
      console.error('product-atc: AddToCart init failed', err);
    }

    this.#host?.addEventListener('pdp:variant-update', this.#onVariantUpdate);
  }

  disconnectedCallback() {
    this.#host?.removeEventListener('pdp:variant-update', this.#onVariantUpdate);
  }

  #onVariantUpdate = (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;

    if (this.#variantInput) {
      this.#variantInput.value = String(variant.id);
    }

    if (this.#priceEl && variant.price_formatted) {
      this.#priceEl.textContent = variant.price_formatted;
    }

    const isAvailable = variant.available !== false;
    if (this.#atcButton) {
      if (isAvailable) this.#atcButton.removeAttribute('hidden');
      else this.#atcButton.setAttribute('hidden', '');
    }
    if (this.#notifyButton) {
      if (isAvailable) this.#notifyButton.setAttribute('hidden', '');
      else this.#notifyButton.removeAttribute('hidden');
    }
  };
}

if (!customElements.get('product-atc')) {
  customElements.define('product-atc', ProductAtc);
}
